function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDaxPopupicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(30.588235%,30.588235%,30.588235%)",
      fillOpacity: 1
    },
    d: "M 22 0 C 23.105469 0 24 0.894531 24 2 L 24 6 L 8 6 C 6.972656 6 6.128906 6.773438 6.011719 7.765625 L 6 8 L 6 24 L 2 24 C 0.894531 24 0 23.105469 0 22 L 0 2 C 0 0.894531 0.894531 0 2 0 Z M 22 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(31.372549%,31.372549%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 30 8 C 31.105469 8 32 8.894531 32 10 L 32 30 C 32 31.105469 31.105469 32 30 32 L 10 32 C 8.894531 32 8 31.105469 8 30 L 8 10 C 8 8.894531 8.894531 8 10 8 Z M 12.242188 12.242188 L 17.898438 26.386719 L 19.785156 22.613281 L 24.96875 27.800781 L 27.800781 24.96875 L 22.613281 19.785156 L 26.386719 17.898438 Z M 12.242188 12.242188 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxPopupicon);
export default __webpack_public_path__ + "static/media/dax-popupicon.696f94a5.svg";
export { ForwardRef as ReactComponent };